const numberWithThousands = (rawNumber, thousands) => rawNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands)

const asCurrency = (amount, decimals=2, symbol='$', thousands=',', point='.') => {
  const numericAmount = typeof amount === 'string' ? Number.parseFloat(amount) : (typeof amount === 'number' ? amount : NaN)
  if (isNaN(numericAmount)) {
    return '- -'
  }
  const neg = numericAmount < 0.0 ? '-' : ''
  const parts = Math.abs(numericAmount).toFixed(decimals).split('.')
  const [lPoint, lDecimals] = decimals > 0 ? [point, parts[1]] : ['', '']
  return [neg, symbol, numberWithThousands(parts[0], thousands), lPoint, lDecimals].join('')
}


const PHONE_TRANSFORMERS = [
  {predicate: (value) => /^04\d{8}$/.test(value), transform: (value) => [...value.matchAll(/^(\d{4})(\d{3})(\d{3})$/g)][0].slice(-3).join(' ') }
]

const asPhoneNumber = (candidate) => {
  if (candidate === undefined || candidate === null || candidate.toString().trim() === '') {
    return candidate
  }
  const base = candidate.toString().replace(/\s+/g, '')
  for (const transformer of PHONE_TRANSFORMERS) {
    if (transformer.predicate(base)) {
      return transformer.transform(base)
    }
  }
  return candidate
}


export { asCurrency, asPhoneNumber }
